import Accordion from './Accordion';
import AccordionIcon from './AccordionIcon';
import AccordionPanel from './AccordionPanel';
import FoldAccordionButton from './FoldAccordionButton';
import NumberAccordionButton from './NumberAccordionButton';
import { useAccordionContext } from './context';

export default {
  NumberAccordionButton,
  FoldAccordionButton,
  AccordionPanel,
  AccordionIcon,
  Accordion
};

export { useAccordionContext };
